document.addEventListener('click', function (event) {
  if (window.PharmedicoAccess?.customerLoggedIn) {
    return;
  }

  const target = event.target.closest('a, label, input');

  if (!target) return;

  const isBeyondBalanceFilter =
    target.href?.includes('filter.p.vendor=Beyond+Balance') ||
    target.value === 'Beyond Balance' ||
    target.textContent?.trim() === 'Beyond Balance';

  if (!isBeyondBalanceFilter) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  window.location.href = '/collections/beyond-balance';
}, true);